export type SignInMethod = 'password' | 'studio:google' | 'studio:microsoft';

// The attempt lives in this tab until Logto accepts the interaction; only then
// does it become the remembered method for later visits.
const attemptKey = 'monoai.sign-in.attempt';
const lastKey = 'monoai.sign-in.last-method';

function parse(value: unknown): SignInMethod | undefined {
  return value === 'password' || value === 'studio:google' || value === 'studio:microsoft'
    ? value
    : undefined;
}

function read(storage: () => Storage, key: string) {
  try {
    return parse(storage().getItem(key));
  } catch {
    // Unavailable storage reads as nothing remembered.
  }
}

export function beginSignInAttempt(method: SignInMethod) {
  try {
    sessionStorage.setItem(attemptKey, method);
  } catch {
    // Storage can be unavailable in private modes; sign-in proceeds without memory.
  }
}

export function hasSignInAttempt() {
  return read(() => sessionStorage, attemptKey) !== undefined;
}

export function recordSignInSuccess() {
  const method = read(() => sessionStorage, attemptKey);
  try {
    sessionStorage.removeItem(attemptKey);
    if (method) {
      localStorage.setItem(lastKey, method);
    }
  } catch {
    // Storage can be unavailable in private modes; sign-in proceeds without memory.
  }
}

export function lastSignInMethod() {
  return read(() => localStorage, lastKey);
}
